import utils from '../../../../utils/utils';

const now = new Date();
const date = new Date(now);
const yearToDate = date.setDate(now.getDate() - 365);

export const queries = (
    filter: any,
    getWhere: any,
    freeSearchText: string,
    currentUser: any
) => ({
    reportCounts: {
        addCount: true,
        limit: 0,
        text: '',
        initialFilter: {},
        where: getWhere(null, filter),
    },
    activityByUser: {
        addCount: true,
        groupBy:
            currentUser &&
            currentUser.userConfiguration &&
            currentUser.userConfiguration.beta
                ? []
                : ['userId'],
        limit: 0,
        where: getWhere(null, filter),
    },
    activityByAction: {
        addCount: true,
        groupBy: ['action'],
        limit: 0,
        where: getWhere(null, filter),
    },
    activityByCollection: {
        addCount: true,
        groupBy: ['collectionName'],
        limit: 0,
        where: getWhere(null, filter),
    },
    activityByCaseId: {
        addCount: true,
        groupBy: ['id'],
        limit: 0,
        where: getWhere(null, filter),
    },
    activityByWorkspaceId: {
        addCount: true,
        groupBy: ['workspaceId'],
        limit: 0,
        where: getWhere(null, filter),
    },
    activitiesPerDay: {
        addCount: true,
        groupBy: ['dateToString(createdAt)'],
        limit: 0,
        text: '',
        initialFilter: {
            dateToString_createdAt: {
                type: 'TEMPORAL',
                gte: `${utils.formatDate(yearToDate, 'YYYY-MM-DD')}`,
                lte: `${utils.formatDate(now, 'YYYY-MM-DD')}`,
            },
        },
        where: getWhere(null, filter),
    },
    activityTable: {
        fields: [
            '_id',
            'userId',
            'collectionName',
            'action',
            'createdAt',
            'transactionId',
            'workspaceId',
        ],
        limit: 10,
        from: 0,
        sortAsc: false,
        sortField: 'createdAt',
        where: getWhere(null, filter),
    },
});

export const dependentQueries = (
    filter: any,
    getWhere: any,
    topCauses: any,
    topMeans: any
) => ({});
